export default function CopyRight(){
    return (
        <div className="App">
            <header className="App-header">
                <p>This will be the copyright page</p>
            </header>
        </div>
    )
}